import { BriefType } from "../../../constants/types";
import { ExecutionBriefProps } from "../../../features/brief-list/types/props/execution-brief.props";
import { WorkOrderProps } from "../../../features/brief-list/types/props/work-order.props";
import { BriefProps } from "../../../features/brief-list/types/props/brief-props.type";

export function createInfoCardTitle(name: string): string {
  return name.length > 64 ? name.substr(0, 63) + "..." : name;
}

export function createInfoCardSubheader(type: BriefType, brief: BriefProps) {
  switch (type) {
    case BriefType.CAMPAIGN_BRIEF:
      return `${brief.startAt} - ${brief.endAt}`;
    case BriefType.EXECUTION_BRIEF:
      return (brief as ExecutionBriefProps).date;
    case BriefType.WORK_ORDER:
      return (brief as WorkOrderProps).dueDate;
  }
}
